import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom"; // Import useParams
import style from "./content_sharing.module.css";
import axios from "axios";
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";



const ContentSharing = () => {
    const { userid } = useParams(); // Extract userid from the URL
    const [contentList, setContentList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const { auth } = useContext(AuthContext);
    const [selfUserId, setSelfUserId] = useState(null);
    const [status, setStatus] = useState(null);
    const [username, setUsername] = useState(null);
    const navigate = useNavigate();

    // comment var
    const [commentList, setCommentList] = useState([]);
    const [newComment, setNewComment] = useState("");
    const [replyingTo, setReplyingTo] = useState(null);
    const [commentUserInfo, setCommentUserInfo] = useState({}); // userid -> { username, avatar }
    const [replyText, setReplyText] = useState("");

    const handleShareInterface = async () => {
        if (currentIndex === null || !contentList[currentIndex]) {
            alert("No content available to share.");
            return;
        }
    
        const contentid = contentList[currentIndex]?.id; 
        const shareUrl = `https://umiuni.com/content_sharing/${userid}/${contentid}`; 
    
        try {
            if (navigator.share) {
                await navigator.share({
                    title: "UmiUni University Alumni",
                    text: "Check out this content!",
                    url: shareUrl,
                });
                await shareDetails();
            } else {
                alert("Sharing is not supported in this browser.");
            }
        } catch (error) {
            console.error("Error opening share interface:", error);
        }
    };
    

    const shareDetails = async () => {
        try {
            const response = await fetch('https://umiuni.com:5002/api/user/user_signin', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: auth.userid,
                    session: auth.session,
                    signin_text: "Share button" 
                })
            });

            const data = await response.json();
            
            if (data.error) {
                console.log("Share detected within 1 minute. No points added.");
                alert(`Successfully shared! No extra point until 1 minute later.`);
            } else {
                console.log(data);
                alert(`Successfully shared! Balance +1 \n Current balance: ${data.balance} points`);
            }
            
        } catch (error) {
            console.error('Error checking in:', error);
            alert('Failed to share. Please try again.');
        }
    };

    
    
    
    const updateStatus = async (action, targetUserId) => {
        try {
            const data = {
                from_user_id: selfUserId,
                to_user_id: targetUserId,
            };

            const url = `https://ai-api.umiuni.com:8183/friends/${action}`;
            const result = await axios.post(url, data, {
                headers: { "Content-Type": "application/json" },
            });

            if (action === "check") {
                console.log(result.data);
                return result.data;
            }
        } catch (error) {
            console.error(error);
        }
    };

    {/* Ensure Initial Ad Push is Safe: */}
    useEffect(() => {
      if (userid === 6949) return;

      try {
        if (window.adsbygoogle && typeof window.adsbygoogle.push === "function") {
            const ads = document.querySelectorAll('.adsbygoogle');
            ads.forEach(ad => {
                if (!ad.hasAttribute('data-adsbygoogle-status')) {
                    window.adsbygoogle.push({});
                }
            });
        }
      } catch (e) {
        console.error("AdSense error:", e);
      }
    }, [userid]);

    {/* Trigger ads only when content updates */} 
    useEffect(() => {
      if (userid === 6949) return;

      setTimeout(() => {
        const ads = document.querySelectorAll('.adsbygoogle');
        ads.forEach(ad => {
            if (!ad.hasAttribute('data-adsbygoogle-status') && ad.offsetWidth > 0) {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        });
      }, 500);  // Delay for 500ms to ensure DOM fully paints
    }, [userid, contentList, currentIndex]);

    {/* Remove Floating Ad with JavaScript (Dynamic Removal): */}
    useEffect(() => {
    if (userid === 6949) return;
    
    setTimeout(() => {
        const floatingAds = document.querySelectorAll('.adsbygoogle:not(.in-article-ad)');
        floatingAds.forEach(ad => {
            ad.parentNode.removeChild(ad);
        });
    }, 500);  // Wait for DOM to render
    }, [userid]);


    useEffect(() => {
        const decryptUserId = async () => {
            try {
                const response = await axios.post(
                    "https://umiuni.com:5002/api/user/decode_userid",
                    { encodedString: auth.userid },
                    { headers: { "Content-Type": "application/json" }, maxBodyLength: Infinity }
                );
                setSelfUserId(response.data.result);
            } catch (error) {
                console.error("Error decrypting user ID:", error);
                throw error;
            }
        };

        if (auth && auth.userid) {
            decryptUserId();
        }
    }, []); 

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const { data } = await axios.get(`https://python.umiuni.com:5555/umiuni_content_getting_self/${userid}/?pwd=testing`);
                setContentList(data);
                setCurrentIndex(data.length > 0 ? data.length - 1 : null);
            } catch (error) {
                console.error(error);
            }
        };

        const fetchUsername = async () => {
            try {
                // Encode the userid
                const encodeResponse = await axios.post(
                    "https://umiuni.com:5002/api/user/encode_userid", 
                    { userid }, 
                    { headers: { "Content-Type": "application/json" }, maxBodyLength: Infinity }
                );
                
                const encodedId = encodeResponse.data.result;
                
                // Fetch the username for the encoded ID
                const userResponse = await axios.get(`${process.env.REACT_APP_API_URL}api/user/get?userid=${encodedId}`);
                setUsername(userResponse.data.username);
            } catch (error) {
                console.error('Error fetching username:', error);
            }
        };

        fetchContent();
        fetchUsername();
    }, [userid]);

    useEffect(() => {
        const checkStatus = async () => {
            if (!selfUserId) return; // Wait for selfUserId to be set
            try {
                const statusResponse = await updateStatus("check", userid);
                setStatus(statusResponse?.status);
            } catch (error) {
                console.error("Error checking status:", error);
            }
        };
    
        checkStatus();
    }, [selfUserId, userid]); // Run when selfUserId is available

    // --- comments: keyed off the currently displayed item's id ---

    const currentContentId = (currentIndex !== null && contentList[currentIndex])
        ? contentList[currentIndex].id
        : null;

    const fetchComment = async (postid) => {
        if (!postid) return;
        try {
            const { data } = await axios.get(`https://python.umiuni.com:5555/umiuni_comment_fetch/?pwd=testing&postid=${postid}`);
            setCommentList(data || []);
            await enrichCommentUsers(data || []);
        } catch (error) {
            console.error(error);
        }
    };

    // Fetch username + avatar for any commenter userid we don't already have cached
    const enrichCommentUsers = async (comments) => {
        const uniqueIds = [...new Set(comments.map(c => c.userid))]
            .filter(id => id != null && !commentUserInfo[id]);

        if (uniqueIds.length === 0) return;

        const results = await Promise.all(
            uniqueIds.map(async (id) => {
                try {
                    const encodeResp = await axios.post(
                        "https://umiuni.com:5002/api/user/encode_userid",
                        { userid: id },
                        { headers: { "Content-Type": "application/json" }, maxBodyLength: Infinity }
                    );
                    const encodedId = encodeResp.data.result;

                    const userResp = await axios.get(`${process.env.REACT_APP_API_URL}api/user/get`, {
                        params: { userid: encodedId },
                    });

                    const pfp = userResp.data.avatar || "94NCQ5GiFeXAVwr3alGqY7Zp9xlzpIGu";
                    return {
                        id,
                        username: userResp.data.username,
                        avatar: `https://oss.umiuni.com/${pfp}`,
                    };
                } catch (error) {
                    console.error(`Error fetching user info for userid ${id}:`, error);
                    return null;
                }
            })
        );

        const newEntries = results.filter(Boolean).reduce((acc, r) => {
            acc[r.id] = { username: r.username, avatar: r.avatar };
            return acc;
        }, {});

        setCommentUserInfo(prev => ({ ...prev, ...newEntries }));
    };

    useEffect(() => {
        // reset and refetch whenever the displayed content item changes
        setCommentList([]);
        setReplyingTo(null);
        setReplyText("");
        setNewComment("");
        if (currentContentId) {
            fetchComment(currentContentId);
        }
    }, [currentContentId]);

    const postComment = async (commentText, commSubId = "") => {
        if (!commentText.trim() || !selfUserId || !currentContentId) {
            console.warn("Cannot post: missing comment text, selfUserId, or contentid", { commentText, selfUserId, currentContentId });
            return;
        }
        try {
            const formData = new FormData();
            formData.append("pwd", "testing");
            formData.append("contentid", currentContentId);
            formData.append("userid", selfUserId);

            const subIdParam = commSubId ? `&comm_subid=${commSubId}` : "";
            const url = `https://python.umiuni.com:5555/umiuni_comment/?pwd=testing&userid=${selfUserId}&postid=${currentContentId}${subIdParam}&comment=${encodeURIComponent(commentText)}`;

            await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            await fetchComment(currentContentId);
        } catch (error) {
            console.error(error);
        }
    };

    const deleteComment = async (commentId, commSubId = null) => {
        if (!selfUserId || !currentContentId) {
            console.warn("Cannot delete: missing selfUserId or contentid");
            return;
        }
        if (!window.confirm("Delete this comment?")) return;
        try {
            const formData = new FormData();
            formData.append("pwd", "testing");
            formData.append("contentid", currentContentId);
            formData.append("userid", selfUserId);

            const subIdParam = commSubId ? `&comm_subid=${commSubId}` : "";
            const url = `https://python.umiuni.com:5555/umiuni_comment_delete/?pwd=testing&userid=${selfUserId}&id=${commentId}&postid=${currentContentId}${subIdParam}`;

            await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            await fetchComment(currentContentId);
        } catch (error) {
            console.error(error);
        }
    };

    const topLevelComments = commentList.filter(c => !c.comm_subid || c.comm_subid == "0");
    const getReplies = (rootId) => commentList.filter(c => c.comm_subid == rootId);

    const renderComment = (comment, depth = 0) => {
        const isOwner = selfUserId && String(comment.userid) === String(selfUserId);
        const isReplying = replyingTo === comment.id;
        const replies = getReplies(comment.id);

        const parentComment = comment.comm_subid && comment.comm_subid != "0"
            ? commentList.find(c => String(c.id) === String(comment.comm_subid))
            : null;

        const threadRootId = comment.comm_subid && comment.comm_subid != "0"
            ? comment.comm_subid
            : comment.id;

        const commenterInfo = commentUserInfo[comment.userid];
        const commenterName = commenterInfo?.username || `User ${comment.userid}`;
        const parentInfo = parentComment ? commentUserInfo[parentComment.userid] : null;
        const parentName = parentComment ? (parentInfo?.username || `User ${parentComment.userid}`) : null;

        return (
            <div key={comment.id} className={style.commentItem} style={{ marginLeft: depth * 30 }}>
                <div className={style.commentHeader}>
                    <div className={style.commentUserInfo}>
                        {commenterInfo?.avatar && (
                            <img src={commenterInfo.avatar} alt={commenterName} className={style.commentAvatar} />
                        )}
                        <span className={style.commentUser}>{commenterName}</span>
                    </div>
                    {comment.created_time && <span className={style.commentTime}>{comment.created_time}</span>}
                </div>

                {parentComment && (
                    <p className={style.replyingToTag}>Replying to {parentName}</p>
                )}

                <p className={style.commentText}>{comment.comment}</p>

                <div className={style.commentActions}>
                    <button
                        className={style.replyButton}
                        onClick={() => {
                            setReplyingTo(isReplying ? null : comment.id);
                            setReplyText("");
                        }}
                    >
                        {isReplying ? "Cancel" : "Reply"}
                    </button>

                    {isOwner && (
                        <button
                            className={style.deleteButton}
                            onClick={() => deleteComment(comment.id, comment.comm_subid && comment.comm_subid != "0" ? comment.comm_subid : null)}
                        >
                            Delete
                        </button>
                    )}
                </div>

                {isReplying && (
                    <div className={style.replyBox}>
                        <input
                            type="text"
                            value={replyText}
                            onChange={(e) => setReplyText(e.target.value)}
                            placeholder="Write a reply..."
                            className={style.commentInput}
                        />
                        <button
                            className={style.submitButton}
                            onClick={async () => {
                                await postComment(replyText, threadRootId);
                                setReplyText("");
                                setReplyingTo(null);
                            }}
                        >
                            Post
                        </button>
                    </div>
                )}

                {replies.length > 0 && (
                    <div className={style.repliesWrapper}>
                        {replies.map(reply => renderComment(reply, depth + 1))}
                    </div>
                )}
            </div>
        );
    };

    const createComments = () => {
        if (!currentContentId) return null;

        return (
            <div className={style.commentsSection}>
                <h3 className={style.commentsTitle}>Comments ({commentList.length})</h3>

                {selfUserId != null && (
                    <div className={style.newCommentBox}>
                        <input
                            type="text"
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            placeholder="Add a comment..."
                            className={style.commentInput}
                        />
                        <button
                            className={style.submitButton}
                            onClick={async () => {
                                await postComment(newComment, "");
                                setNewComment("");
                            }}
                        >
                            Post
                        </button>
                    </div>
                )}

                <div className={style.commentsList}>
                    {topLevelComments.length === 0 ? (
                        <p className={style.noComments}>No comments yet.</p>
                    ) : (
                        topLevelComments.map(comment => renderComment(comment))
                    )}
                </div>
            </div>
        );
    };

    const changeContent = (direction) => {
        if (contentList.length <= 1) return;
    
        setCurrentIndex(prevIndex => {
            if (direction === 'r') {
                return (prevIndex <= 0) ? contentList.length - 1 : prevIndex - 1;
            } else if (direction === 'l') {
                return (prevIndex >= contentList.length - 1) ? 0 : prevIndex + 1;
            }
            return prevIndex;
        });
    };   


   const createCards = () => {
     if (contentList.length === 0 || currentIndex === null) return null;

     const item = contentList[currentIndex];

     // Additional fields
     const additionalFields = {
	id: item.id || null,
        userid: item.userid || null,
        created_time: item.created_time || null,
        photo_location: item.photo_location || null,
        content_name: item.content_name || null,
        page_num: item.page_num || null,
        text: item.text || null,
        book_link: item.book_link || null,
     };

     const handleStatus = async () => {
        if (auth.userid) {
            const action = status === "following" ? "remove" : "follow";
            await updateStatus(action, additionalFields.userid);

            setStatus(status === "following" ? "none" : "following");
        } else {
            alert("Please login first!");
        }
        // rebase your env before making any changes and committing to main plz
    };

    const handleDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this post?');
        if (!userConfirmed) return;
    
        try {
            const FormData = require('form-data');
            let data = new FormData();
            data.append('pwd', 'testing');
            data.append('contentid', additionalFields.id);
            data.append('userid', additionalFields.userid);
    
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://python.umiuni.com:5555/umiuni_delete_content/',
                data: data
            };
    
            const response = await axios.request(config);
            console.log(response.data);
        } catch (error) {
            console.error('Error during delete:', error);
        }
    }

     return (
        <div style={{paddingTop:'1rem'}}>
            <div className={style.contentWrapper} key={currentIndex}>
                <div className={style.content}>
                    <button className={style.leftButton} onClick={() => changeContent('l')}><IoIosArrowBack /></button>
                    {item.photo_location?.endsWith('.pdf') ? (
                        <a href={item.photo_location}>{item.content_name}</a>
                    ) : (
                        <img src={item.photo_location} alt={item.content_name} />
                    )}
                    <button className={style.rightButton} onClick={() => changeContent('r')}><IoIosArrowForward /></button>
                </div>
                {/* Display additional fields if they are not null */}
                <div className={style.additionalInfo}>
                    {additionalFields.userid && (
                        <>
                            <p className={style.userIdCont}>User ID: {additionalFields.userid}</p>
                            {additionalFields.userid != selfUserId && (<button className={style.updateStatus} onClick={handleStatus}>
                                {status === "following" ? "Unsubscribe" : "Subscribe"}
                            </button>)}

                            {additionalFields.userid == selfUserId && (<button className={style.updateStatus} onClick={handleDelete}>
                                Delete
                            </button>)}

                            <button
                                onClick={handleShareInterface} 
                                className={style.updateStatus}
                            >
                                Share
                            </button>


                        </>
                    )}
                    {additionalFields.created_time && <p>Created Time: {additionalFields.created_time}</p>}
                    {additionalFields.page_num && <p>Page Number: {additionalFields.page_num}</p>}
                {additionalFields.content_name && (
                <div className={style.addBook} style={{ width: '100%' }}>
                            <p>Book Name: {additionalFields.content_name}</p>
                            </div>
                    )}
                    {additionalFields.text && <p>Text: {additionalFields.text}</p>}
                    {additionalFields.book_link && (
                        <div className={style.addBook}>
                            <p>Book Link:</p>
                            <a href={additionalFields.book_link}>View Book</a>
                        </div>
                    )}
                            {userid != 6949 &&
                                <div className={style.adWrapper}>
                                    <ins className="adsbygoogle in-article-ad"
                                    style={{ display: 'block', textAlign: 'center' }}
                                    data-ad-client="ca-pub-6469196979031643"
                                    data-ad-slot="7644150363"
                                    data-ad-format="auto"
                                    data-full-width-responsive="true">
                                    </ins>
                                </div>
                            }
                            

            </div>

                <button className={style.closeButton} onClick={() => navigate('/')}><IoIosArrowBack /></button>
            </div>

            {createComments()}
        </div>
    );
   };

    return (
        <div className={style.contentCards}>
            {createCards()}
        </div>
    );
};

export default ContentSharing;